import * as Yup from "yup";

let validationSchema = Yup.object({
  email: Yup.string("Email is Required")
    .required("Email is Required")
    .email("Email Must be Valid"),
 
});
export default validationSchema;
